import React from "react"
import "./Iconos.css"
import { MdDescription } from "react-icons/md"

const IconoContratos = (props) => {
  return (
    <span
      className={"icono-mp" + (props.background ? " background-contratos" : "")}
    >
      <MdDescription />
    </span>
  )
}

export default IconoContratos
